import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { inject } from '@angular/core';

export const AdminGuard: CanActivateFn = (): boolean | UrlTree =>
  inject(UserAuthenticationService).isAdmin() || inject(Router).parseUrl('/welcome');
